import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';

function PrivacyPolicy({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1>{t('privacy_title')}</h1>
      <p>{t('privacy_p1')}</p>
      <p><strong>{t('privacy_last_updated_label')}</strong> {t('privacy_last_updated_value')}</p>
      
      <h2>{t('privacy_h2_info')}</h2>
      <p>{t('privacy_p2')}</p>
      <ul>
        <li>{t('privacy_list_item1')}</li>
        <li>{t('privacy_list_item2')}</li>
      </ul>

      <h2>{t('privacy_h2_use')}</h2>
      <p>{t('privacy_p3')}</p>
      <ul>
        <li>{t('privacy_list_item3')}</li>
        <li>{t('privacy_list_item4')}</li>
        <li>{t('privacy_list_item5')}</li>
      </ul>

      <h2>{t('privacy_h2_services')}</h2>
      <p>{t('privacy_p4')}</p>

      <h2>{t('privacy_h2_ads')}</h2>
      <p>{t('privacy_ads_p1')}</p>
      <ul>
        <li>{t('privacy_ads_list_item1')}</li>
        <li>{t('privacy_ads_list_item2')}</li>
        <li>{t('privacy_ads_list_item3')}</li>
      </ul>

      <h2>{t('privacy_h2_choices')}</h2>
      <p>{t('privacy_choices_p1')}</p>
      <ul>
        <li>{t('privacy_choices_list_item1')}</li>
        <li>{t('privacy_choices_list_item2')}</li>
      </ul>

      <h2>{t('privacy_h2_children')}</h2>
      <p>{t('privacy_p5')}</p>

      <h2>{t('privacy_h2_changes')}</h2>
      <p>{t('privacy_p6')}</p>

      <h2>{t('privacy_h2_contact')}</h2>
      <p>{t('privacy_p7')} <strong>{t('contact_p2')}</strong></p>

      <button className="back-button" onClick={onBack}>{t('back_to_home')}</button>
    </div>
  );
}
export default PrivacyPolicy;
